import { useEffect, useRef, useState } from "react";

import Swal from "sweetalert2";

let queue = Promise.resolve();

export const notify = (type, title, message, onClose = () => { }) => {
    queue = queue.then(() => {
        return new Promise((resolve) => {
            const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                // timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    // toast.addEventListener("mouseenter", Swal.stopTimer);
                    // toast.addEventListener("mouseleave", Swal.resumeTimer);
                    // onClose()
                },
                willClose: () => {
                    resolve(); // 👈 important: releases queue
                    onClose()

                },
            });

            Toast.fire({
                icon: type,
                title: title,
                text: message
            });
        });
    });
};
const safeParse = (data) => {
    try {
        // first parse
        const parsed = JSON.parse(data);

        // if still string, parse again (double encoded case)
        if (typeof parsed === "string") {
            return JSON.parse(parsed);
        }

        return parsed;
    } catch (e) {
        return data; // fallback raw
    }
};

export function useSSE(url, options = {}) {


    const {
        onMessage,
        onOpen,
        onError,
        autoReconnect = true,
        reconnectDelay = 3000,
    } = options;

    const sourceRef = useRef(null);
    const reconnectTimer = useRef(null);

    const [connected, setConnected] = useState(false);
    const [lastMessage, setLastMessage] = useState(null);
    const [error, setError] = useState(null);

    const connect = () => {
        if (!url) return; // 👈 safe guard, NOT hook condition
        const source = new EventSource(url);

        sourceRef.current = source;

        source.onopen = (event) => {
            setConnected(true);
            setError(null);

            if (onOpen) {
                onOpen(event);
            }
        };

        source.onmessage = (event) => {
            try {
                console.log("SSE", event.data)
                const data = safeParse(event.data);

                setLastMessage(data);

                if (onMessage) {
                    onMessage(data);
                }
            } catch {
                alert("error")
                setLastMessage(event.data);

                if (onMessage) {
                    onMessage(event.data);
                }
            }
        };

        source.onerror = (event) => {
            setConnected(false);
            setError(event);

            if (onError) {
                onError(event);
            }

            source.close();

            if (autoReconnect) {
                reconnectTimer.current = setTimeout(
                    connect,
                    reconnectDelay
                );
            }
        };
    };

    useEffect(() => {
        connect();

        return () => {
            if (sourceRef.current) {
                sourceRef.current.close();
            }

            if (reconnectTimer.current) {
                clearTimeout(reconnectTimer.current);
            }
        };
    }, [url]);

    return {
        connected,
        lastMessage,
        error,
        close: () => sourceRef.current?.close(),
    };
}


export function SSEListener({
    url,
    onMessage,
    children,
}) {
    const {
        connected,
        lastMessage,
    } = useSSE(url, {
        onMessage,
    });

    return children({
        connected,
        lastMessage,
    });
}
export default {
    useSSE,
    SSEListener
}